import { Link, useLocation } from "react-router-dom";

const PROSPECTION_NAV = [
  { to: "/prospection", label: "Prospection" },
  { to: "/calendrier", label: "Calendrier" },
  { to: "/statistiques", label: "Statistiques" },
];

const ACQUISITION_NAV = [
  { to: "/acquisition", label: "Aujourd'hui", exact: true },
  { to: "/acquisition/clients", label: "Clients" },
  { to: "/acquisition/contenus", label: "Contenus" },
  { to: "/acquisition/resultats", label: "Résultats" },
];

export const AppHeader = ({ actions }) => {
  const { pathname } = useLocation();
  const NAV = pathname.startsWith("/acquisition") ? ACQUISITION_NAV : PROSPECTION_NAV;
  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-sm border-b border-brand-line">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12 py-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 sm:gap-6 min-w-0">
          <Link to="/" className="flex items-center gap-3 sm:gap-4 min-w-0" data-testid="brand-home-link">
            <img src="/picto-instant.png" alt="Instan.t" className="h-8 w-8 sm:h-9 sm:w-9 object-contain flex-shrink-0" data-testid="brand-picto" />
            <div className="h-9 w-px bg-brand-line hidden sm:block" />
            <div className="min-w-0 leading-none">
              <div className="font-display text-xl sm:text-2xl text-brand-ink truncate" data-testid="brand-title">Studio</div>
              <div className="eyebrow mt-1 truncate">by Instan.t</div>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-1 ml-4" data-testid="main-nav">
            {NAV.map((item) => {
              const active = item.exact ? pathname === item.to : pathname.startsWith(item.to);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  data-testid={`nav-${item.label.toLowerCase()}`}
                  className={`px-3 py-2 rounded-md text-[11px] font-mono uppercase tracking-[0.16em] transition-colors ${
                    active
                      ? "bg-brand-moss text-white"
                      : "text-brand-subtle hover:text-brand-ink hover:bg-brand-paper"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>
      </div>

      {/* Nav mobile */}
      <nav className="md:hidden flex items-center gap-1 px-4 pb-3 -mt-1" data-testid="main-nav-mobile">
        {NAV.map((item) => {
          const active = item.exact ? pathname === item.to : pathname.startsWith(item.to);
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`flex-1 text-center px-2 py-2 rounded-md text-[10px] font-mono uppercase tracking-[0.14em] ${
                active ? "bg-brand-moss text-white" : "text-brand-subtle bg-brand-paper"
              }`}
            >
              {item.label}
            </Link>
          );
        })}
      </nav>
    </header>
  );
};
